$("#galeria .items")
    .slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        dots: false,
        prevArrow:
            '<a class="slick-arrow slick-arrow-prev" href="javascript:void(null);">&leftarrow;</a>',
        nextArrow:
            '<a class="slick-arrow slick-arrow-next" href="javascript:void(null);">&rightarrow;</a>',
    })
    .on("afterChange", function (event, slick, num) {
        const $current = $("#galeria .slick-current .imagen");
        const $titulo = $("#galeria .inferior-in");
        const titulo = $current.find("img").attr("alt");
        $titulo.html(titulo);
    });

if ($("#galeria-conoce").length) {
    $("#galeria-slide").slick({
        dots: false,
        infinite: true,
        speed: 300,
        autoplay: false,
        slidesToShow: 3,
        centerMode: true,
        centerPadding: "0",
        slidesToScroll: 1,
        appendArrows: $("#galeria-conoce .arrows"),
        appendDots: $("#galeria-conoce .dots"),
        prevArrow:
            '<a href="javascript:void(null);" class="arrow arrow-left"><img src="/images/proyecto-casa/flecha_izquierda_dark.svg"/></a>',
        nextArrow:
            '<a href="javascript:void(null);" class="arrow arrow-right"><img src="/images/proyecto-casa/flecha_derecha_dark.svg"/></a>',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });
}